var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "slider_x0020_styl",
    d: "M13 3.5C13 2.1 11.9 1 10.5 1h-7C2.1 1 1 2.1 1 3.5v7.3c0 .6.1 1.2.6 1.6l4 4c.8.8 2 .8 2.8 0l4-4c.4-.4.6-1 .6-1.6V3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.ac06df5f76449ff21bef893114e59bcd.svg";
export { ForwardRef as ReactComponent };